module.exports = __webpack_public_path__ + "static/img/10.c0dc2ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/zh/10.png
// module id = PX3G
// module chunks = 0